import Database from 'database';

export const Types = {
  GET_CULTURAS: 'culturas/GET_CULTURAS',
  GET_CULTURAS_SUCCESS: 'culturas/GET_CULTURAS_SUCCESS',
  GET_CULTURAS_FAILED: 'culturas/GET_CULTURAS_FAILED',
};

const initialState = {
  loading: false,
  error: null,
  data: [],
};

export default function culturasReducer(state = initialState, action) {
  switch (action.type) {
    case Types.GET_CULTURAS:
      return { ...state, loading: true };
    case Types.GET_CULTURAS_SUCCESS:
      return { ...state, loading: false, data: [...action.payload.data] };
    case Types.GET_CULTURAS_FAILED:
      return { ...state, loading: false, error: action.payload.error };
    default:
      return state;
  }
}

export const Creators = {
  getCulturas: () => async (dispatch) => {
    try {
      dispatch({ type: Types.GET_CULTURAS });
      const culturas = await Database.culturas.toArray();
      dispatch({ type: Types.GET_CULTURAS_SUCCESS, payload: { data: culturas } });
    } catch (woof) {
      console.error(woof.message);
      dispatch({ type: Types.GET_CULTURAS_FAILED, payload: { error: 'Serviço indisponível' } });
    }
  },
};
